import MultiselectAsync from "./Multiselect/MultiselectAsync.vue";
import Multiselect from "./Multiselect/Multiselect.vue";
import Bag from "./Bag/Bag.vue";
// import Datepicker from './DatePicker.vue';
import { VueEditor } from "vue2-editor";

Vue.component("multiselect-async", MultiselectAsync);
Vue.component("multiselect", Multiselect); // The base multiselect component
Vue.component("bag", Bag);
// Vue.component("datepicker", Datepicker);
Vue.component("vueeditor", VueEditor);